<template>
	<div class="paddingbottom50">
	<van-pull-refresh v-model="isLoading" @refresh="onRefresh">
		<van-list v-model="loading" :finished="finished" finished-text="加载完毕" @load="onLoad">
			<div class="">
				<div v-for="(item,index) in list" :key="index" class="marginBottomXm setWhite" @click="go('/pages/detail/detail?id='+item.id)" >
						  <van-row type="flex" justify="center" style="padding: 10px 0;">
						    <van-col span="23">
						      <div class="adPic">
							  <van-image
							    fit="cover"
								lazy-load
								:src="item.face?item.face:yanxuebg"
							    width="100%"
								style="border-radius: 10px;overflow: hidden;"
							  >
							   <template  slot="loading">
							      <van-loading type="spinner" size="20" />
							    </template>
							   <template slot="error" >
									  <div style="text-align: center;">
										  <van-icon name="warning-o" size="30"></van-icon>
										  <div>加载失败</div>
									  </div>
							   </template>
							   </van-image>
						      </div>
						      <van-row style="padding: 5px 0">
						          <van-col span="24">
						            <div  class="cardTitle van-ellipsis">{{item.title}}</div>
						          </van-col>
						       </van-row>
							   <div>
							   	<van-tag round type="success">截止日期:{{item.end_date}}</van-tag>
							   </div>
						    </van-col>
						  </van-row>
				</div>
				
			</div>
		</van-list>
		
		
	</van-pull-refresh>
	</div>
</template>

<script>
	import {mapState,mapMutations} from 'vuex';
	export default {
		props:['city','search','type'],
		computed: {
			// ...mapState(['site','token']),
		},
		data(){
			return{
				yanxuebg:'http://img.jiarixiaodui.com/jrhb/web_img/photo.jpg?x-oss-process=image/resize,m_fill,h_320,w_600',
				list: [],
				page: 0,
				limits: 10,
				loading: false,
				finished: false,
				isLoading: false,
			}
		},
		watch: {
			"city": function(val) {
		         this.reload();
			},
			"search": function(val) {
			     this.reload();
			},
			"type": function(val) {
			     this.reload();
			},
		},
		created() {
			
		},
		methods:{
			onRefresh() {
				setTimeout(() => {
					this.$toast('刷新成功');
					this.isLoading = false;
					this.reload();
				}, 500);
			},
			onLoad() {
				setTimeout(() => {
					this.loadData();
				}, 500);
			},
			reload() {
				this.page = 0;
				this.list = [];
				this.loading = false;
				this.finished = false;
				this.onLoad();
			},
			go(name) {
				this.$router.push(`${name}`);
			},
			loadData() {
				const that = this;
				let type='';
				this.type=='全部活动'?type='':type=this.type;
				try {
					that.page++;
					that.$axios.get('party?limit=' + that.limits + '&page=' + that.page + '&site=' + that.city+"&search="+that.search+"&class="+type).then(response => {
						let data = response.data.data;
						for (let i = 0; i < data.length; i++) {
							if(data[i].face){
							data[i].face='http://img.jiarixiaodui.com/'+data[i].face+'?x-oss-process=image/resize,m_fill,h_320,w_600';
							};
							that.list.push(data[i]);
						}
						that.loading = false;
						if (response.data.data.length == 0) {
							that.finished = true;
						}
					});
				} catch (e) {
					if (this.$mConfig.debug) {
						console.log(e);
					};
				}
			}
		}
		}
</script>

<style scoped="scoped">
	
</style>
